module.exports = require('gl-quat/slerp')


//////////////////
// WEBPACK FOOTER
// ./node_modules/quat-slerp/index.js
// module id = 54
// module chunks = 0